import { render } from "./AdressForm.vue?vue&type=template&id=073b93cc&scoped=true"
import script from "./AdressForm.vue?vue&type=script&lang=js"
export * from "./AdressForm.vue?vue&type=script&lang=js"

import "./AdressForm.vue?vue&type=style&index=0&id=073b93cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073b93cc"]])

export default __exports__